/* @flow */

import remote from './remote';

type Data = {
  [string]: any
};

type Query = {
  [string]: any
};

export function clearFavorites() {
  return remote.post('lineups/clear-featured');
}

export function crunchLineUps(data) {
  return remote.post('lineups/crunch-lineups?embed=games.players', data);
}

export function downloadCrunchedLineUps(data) {
  return remote.post('lineups/download-crunched-lineups', data);
}

export function saveCrunchedLineUps(data) {
  return remote.post('lineups/save-crunched-lineups', data);
}

export function saveProjection(data) {
  return remote.post('lineups/projection', data);
}

export function loadProjections(slateId) {
  return remote.get(`lineups/${slateId}/projections`);
}

export function deleteChallenges(ids) {
  return remote.delete('challenges', { ids });
}

export function deleteLineups(query) {
  return remote.delete('lineups', query);
}

export function downloadTemplate(data) {
  return remote.post('lineups/download-template', data);
}

export function downloadUpcoming(data) {
  return remote.post('lineups/download-upcoming', data);
}

export function uploadLineups(data) {
  return remote.post('lineups/upload', data);
}

export function uploadUpcoming(data) {
  return remote.post('lineups/upload-upcoming', data);
}

export function getUpcomingChallenges(query: Query = {}) {
  return remote.get('upcoming_challenges', query);
}

export function getUpcomingH2HChallenges(query: Query = {}) {
  return remote.get('upcoming_h2h_challenges', query);
}

export function getUpcomingCustomChallenges(query: Query = {}) {
  return remote.get('custom_challenges/upcoming', query);
}

export function getCompatibleChallenges(query: Query) {
  return remote.get('challenges/compatible', query);
}

export function getLiveChallenges(query: Query = {}) {
  return remote.get('live_challenges', query);
}

export function getMyChallenges(query: Query = {}) {
  return remote.get('my-challenges', query);
}

export function getMyChallengeEntries(challengeId: string) {
  return remote.get(`challenges/${challengeId}/my-entries`);
}

export function getChallenge(id: string, query: Query = {}) {
  return remote.get(`challenges/${id}`, query);
}

export function getChallenges(query: Query = {}) {
  return remote.get('challenges', query);
}

export function getEntries(query: Query = {}) {
  return remote.get('entries/my-entries', query);
}

export function getEntry(id: string) {
  return remote.get(`entries/${id}`);
}

export function getPrizes(challengeId: string, query: Query = {}) {
  return remote.get(`challenges/${challengeId}/prizes`, query);
}

export function getGames(challengeId: string) {
  return remote.get(`challenges/${challengeId}/games`);
}

export function getChallengeEntries(challengeId: string, query: Query = {}) {
  return remote.get(`challenges/${challengeId}/entries`, query);
}

export function getChallengeProjectedEntries(challengeId: string, query: Query = {}) {
  return remote.get(`challenges/${challengeId}/projected-entries`, query);
}

export function getChallengeUsers(challengeId: string, query: Query = {}) {
  return remote.get(`challenges/${challengeId}/users`, query);
}

export function getMyEntries(query: Query = {}) {
  return remote.get('entries/my-entries', query);
}

export function getLineUps(query: Query) {
  return remote.get('lineups/my-lineups', query);
}

export function getLineUp(id: number) {
  return remote.get(`lineups/${id}`);
}

export function getSlateLineUps(query: Query) {
  return remote.get('lineups/my-slate-lineups', query);
}

export function getMySlate(id, query = {}) {
  return remote.get(`slates/${id}`, query);
}

export function getMySlates(query) {
  return remote.get('slates/my-slates', query);
}

export function getLineupChallenges(lineupId: number, query: Query) {
  return remote.get(`lineups/${lineupId}/challenges`, query);
}

export function submitEntry(challengeId: string, data: Data) {
  return remote.post(`challenges/${challengeId}/entries`, data);
}

export function submitTrainingEntry(challengeId: string, data: Data) {
  return remote.post(`challenges/${challengeId}/training-entries`, data);
}

export function submitMultipleEntries(challengeId: string, data: Data) {
  return remote.post(`challenges/${challengeId}/entries/multiple`, data);
}

export function submitPxcEntries(data: Data) {
  return remote.post('play_xchange/entries', data);
}

export function submitPlayerSwap(data: Data) {
  return remote.put('lineups/swap-selection', data);
}

export function toggleLineupFavorite(id: number, featured: boolean) {
  return remote.put(`lineups/${id}/feature`, { featured });
}

export function updateEntry(id: string, data: Data) {
  return remote.post(`entries/${id}`, data);
}

export function updateLineup(id, data: Data) {
  return remote.put(`lineups/${id}`, data);
}

export function updateTrainingEntry(id: string, data: Data) {
  return remote.post(`training-entries/${id}`, data);
}

export function bulkUpdate(data: Data) {
  return remote.put('entries/bulk-update', data);
}

export function shareChallenge(challengeId: string, data: Data) {
  return remote.post(`challenges/${challengeId}/share`, data);
}

export function getMyHistoryEntries(query = {}) {
  return remote.get('entries/my-historical-entries', query);
}
